"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbNav = BreadcrumbNav;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var react_1 = require("@heroui/react");
// Route to label mappings
var routeLabels = {
    dashboard: "Dashboard",
    organizations: "Organizations",
    roles: "Roles",
    users: "Users",
    products: "Products",
    stock: "Stock",
    orders: "Orders",
    disbursements: "Disbursements",
    reports: "Reports",
    ussd: "USSD",
    new: "Create",
    edit: "Edit",
    detail: "Details",
    upload: "Upload",
    pending: "Pending Authorization",
    billing: "Billing",
    audit: "Audit",
};
function BreadcrumbNav() {
    var location = (0, react_router_dom_1.useLocation)();
    var getBreadcrumbs = function () {
        var pathnames = location.pathname.split("/").filter(function (x) { return x; });
        var breadcrumbs = [];
        var currentPath = "";
        pathnames.forEach(function (segment, index) {
            currentPath += "/".concat(segment);
            // Check if segment is an ID (typically a MongoDB ObjectId or UUID)
            var isId = /^[a-f0-9]{24}$/.test(segment) ||
                /^[0-9a-fA-F-]{36}$/.test(segment) ||
                /^\d+$/.test(segment);
            if (isId) {
                // For IDs, we just show "Details" or the ID
                breadcrumbs.push({
                    label: "Details",
                    path: index === pathnames.length - 1 ? undefined : currentPath,
                });
            }
            else {
                var label = routeLabels[segment] || capitalize(segment);
                breadcrumbs.push({
                    label: label,
                    path: index === pathnames.length - 1 ? undefined : currentPath,
                });
            }
        });
        return breadcrumbs;
    };
    var capitalize = function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1).replace(/-/g, " ");
    };
    var breadcrumbs = getBreadcrumbs();
    if (breadcrumbs.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(react_1.Breadcrumbs, { variant: "solid", size: "sm", children: breadcrumbs.map(function (crumb, index) { return ((0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { children: crumb.path ? ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: crumb.path, className: "text-default-500 hover:text-primary", children: crumb.label })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-foreground", children: crumb.label })) }, index)); }) }));
}
